import { render } from "./NegociacoesEfetivadas.vue?vue&type=template&id=5912710a"
import script from "./NegociacoesEfetivadas.vue?vue&type=script&lang=js"
export * from "./NegociacoesEfetivadas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__